<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Store"
              bc1="App"
              bc2="Store"
              bc3="Groups"
              path="Store"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <!-- Main Content Column -->
            <div class="col-md-6 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Group Stores</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal" @submit.prevent>
                    <div class="row">
                      <div class="col-md-12 user_status mb-2">
                        <div class="input-group">
                          <input class="form-control" type="text" v-model="search" placeholder="Search stores..."/>
                          <div class="input-group-append">
                            <button type="button" class="btn btn-primary" @click="handleSearch" :disabled="loadingSearch">
                              <span v-if="!loadingSearch">Search</span>
                              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Stores</h6>
                      <div class="col-12 mb-2">
                        <div class="custom-control custom-switch mb-1" v-for="(channel, index) in channelList" :key="index">
                          <input
                              :id="'store-' + channel.id"
                              type="checkbox"
                              class="custom-control-input"
                              v-model="channel.checked"
                              @change="updateSelection(channel.id, channel.checked)"
                          />
                          <label class="custom-control-label text-break" :for="'store-' + channel.id">
                            {{ customNameForMultiselect(channel) }}
                          </label>
                        </div>
                      </div>
                      <div class="col-12 text-center" v-if="hasMoreItems && !loadingMore">
                        <button class="btn btn-primary btn-sm" @click="loadMore">
                          Load More
                        </button>
                      </div>
                      <div class="col-12 text-center" v-if="loadingMore">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                      <div class="col-12 text-muted text-center" v-if="!hasMoreItems && channelList.length > 0">
                        No more stores to load
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Selected Stores Panel -->
            <div class="col-md-6 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title d-flex justify-content-between align-items-center">
                    Selected Stores
                    <span class="badge badge-pill ml-1 badge-light-primary">
                      {{ Object.keys(selectedChannels).length }}
                    </span>
                  </h4>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <tbody>
                      <tr v-for="(channel, id) in selectedChannels" :key="id">
                        <td class="pr-0">
                          <button
                              type="button"
                              class="btn btn-sm btn-icon rounded-circle"
                              @click="confirmRemoveSelection(id)"
                          >
                            <i class="fas fa-times text-danger"></i>
                          </button>
                        </td>
                        <td class="py-1 text-break">
                          <small>{{ getChannelName(id) }}</small>
                        </td>
                      </tr>
                      <tr v-if="Object.keys(selectedChannels).length === 0">
                        <td colspan="2" class="text-center text-muted py-2">
                          No stores selected
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer d-flex justify-content-between align-items-center">
                  <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="confirmClearAllSelections"
                      v-if="Object.keys(selectedChannels).length > 0"
                  >
                    Clear All
                  </button>
                  <button type="button" class="btn btn-primary" @click="sendCall" :disabled="loading">
                    <span v-if="!loading">Save Changes</span>
                    <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
    <CustomConfirmationModal
        v-if="showConfirmationModal"
        :show="showConfirmationModal"
        :title="modalTitle"
        :message="modalMessage"
        @hide="showConfirmationModal = false"
        @confirm="executeConfirmedAction"
    />
  </div>
  <!-- END: Content-->
</template>

<script>
import CustomConfirmationModal from "@/pages/dashboard/schema/customConfirmationModal.vue";

export default {
  components: {CustomConfirmationModal},
  mounted() {
    this.getAllChannels()

    var groupsStore = this.$store.getters.getByKey(
        "groupsStore"
    );
    this.groupId = groupsStore.row.id

    var stores = groupsStore.row.stores

    if (stores) {
      stores.forEach(eachStore => {
        this.$set(this.selectedChannels, eachStore.id, true);
        this.$set(this.channelNames, eachStore.id, this.customNameForMultiselect({store: eachStore, user: eachStore.user}));
      });
    }
  },
  data() {
    return {
      loader: false,
      channelList: [],
      fetchedCount: 0,
      intactChannelList: [],
      selectedChannels: {},
      channelNames: {},
      explicitlyUnselectedChannels: {},
      loading: false,
      size: "10px",
      groupId: '',
      search: '',
      paginationData: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      loadingMore: false,
      loadingSearch: false,
      currentSearchQuery: '',
      hasLoadedInitialSelections: false,
      showConfirmationModal: false,
      modalTitle: '',
      modalMessage: '',
      pendingAction: null,
      pendingActionData: null,
    }
  },
  computed: {
    hasMoreItems() {
      return this.fetchedCount < this.paginationData.total;
    }
  },
  methods: {
    customNameForMultiselect(channel) {
      let name = ''
      if(channel.user){
        name+= channel.user?.email + '/'
      }
      if (channel.store) {
        name += channel.store.name
      }

      return name
    },
    confirmRemoveSelection(id) {
      const channelName = this.getChannelName(id);
      this.modalTitle = 'Confirm Removal';
      this.modalMessage = `Are you sure you want to remove "${channelName}" from selected stores?`;
      this.pendingAction = 'remove';
      this.pendingActionData = id;
      this.showConfirmationModal = true;
    },

    confirmClearAllSelections() {
      this.modalTitle = 'Confirm Clear All';
      this.modalMessage = 'Are you sure you want to remove all selected stores?';
      this.pendingAction = 'clearAll';
      this.showConfirmationModal = true;
    },

    executeConfirmedAction() {
      if (this.pendingAction === 'remove') {
        this.removeSelection(this.pendingActionData);
      } else if (this.pendingAction === 'clearAll') {
        this.clearAllSelections();
      }
      this.showConfirmationModal = false;
      this.pendingAction = null;
      this.pendingActionData = null;
    },

    removeSelection(id) {
      this.$delete(this.selectedChannels, id);
      this.$set(this.explicitlyUnselectedChannels, id, true);
      const item = this.channelList.find(c => c.id == id);
      if (item) item.checked = false;
    },

    clearAllSelections() {
      this.channelList.forEach(item => {
        item.checked = false;
      });
      this.selectedChannels = {};
      this.explicitlyUnselectedChannels = {};
    },

    handleSearch() {
      if (this.loadingSearch) return;

      this.loadingSearch = true;
      this.currentSearchQuery = this.search;
      this.paginationData.currentPage = 1;
      this.channelList = [];

      this.getAllChannels(true).finally(() => {
        this.loadingSearch = false;
      });
    },

    loadMore() {
      if (this.hasMoreItems && !this.loadingMore) {
        this.paginationData.currentPage++;
        this.getAllChannels(!!this.currentSearchQuery);
      }
    },

    updateSelection(id, isChecked) {
      if (isChecked) {
        this.$set(this.selectedChannels, id, true);
        this.$delete(this.explicitlyUnselectedChannels, id);
        const item = this.channelList.find(c => c.id == id) ||
            this.intactChannelList.find(c => c.id == id);
        if (item) {
          this.$set(this.channelNames, id, this.customNameForMultiselect(item));
        }
      } else {
        this.$delete(this.selectedChannels, id);
        this.$set(this.explicitlyUnselectedChannels, id, true);
      }
    },

    getChannelName(id) {
      return this.channelNames[id] || `Store ${id}`;
    },

    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let stores = Object.keys(this.selectedChannels);

          let data = {
            stores: JSON.stringify(stores),
            groupId: this.groupId,
          }

          this.makeRequest("post", "v1/manage-group-stores", data).then(
              callResponse => {
                this.loading = false;
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.$router.back()
                  }
                }
              }
          );
        }
      });
    },

    getAllChannels(forSearch = false) {
      this.loadingMore = true;

      let requestData = {
        paginate: true,
        page: this.paginationData.currentPage,
        perPage: this.paginationData.perPage,
        // status: 1
      };

      if (this.currentSearchQuery) {
        requestData.search = this.currentSearchQuery;
      }

      return this.makeRequest('post', 'v1/get-store', requestData, {}, false)
          .then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                const newItems = callResponse.response.data.data.data;
                this.fetchedCount = (this.paginationData.currentPage === 1 ? 0 : this.fetchedCount) + newItems.length;

                // One toggle per store row; keep the {store, user} shape the rest of the page expects
                const existingStoreIds = this.paginationData.currentPage === 1 ? [] : this.channelList.map(c => c.id);
                const processedItems = [];
                newItems.forEach(item => {
                  if (existingStoreIds.includes(item.id)) return;
                  existingStoreIds.push(item.id);
                  processedItems.push({
                    id: item.id,
                    store: item,
                    user: item.user,
                    checked: !!this.selectedChannels[item.id] &&
                        !this.explicitlyUnselectedChannels[item.id]
                  });
                });

                if (callResponse.response.data.data.paginationData) {
                  this.paginationData = {
                    ...this.paginationData,
                    ...callResponse.response.data.data.paginationData
                  };
                }

                if (this.paginationData.currentPage === 1) {
                  this.channelList = processedItems;
                } else {
                  this.channelList = [...this.channelList, ...processedItems];
                }

                if (!this.hasLoadedInitialSelections) {
                  this.hasLoadedInitialSelections = true;
                }

                if(this.intactChannelList.length == 0) {
                  this.intactChannelList = [...this.channelList];
                }
              }
            }
          })
          .finally(() => {
            this.loadingMore = false;
          });
    },
  }
}
</script>

<style scoped>
.table td {
  vertical-align: middle;
}
.btn-icon {
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.card-footer {
  background-color: #f8f9fa;
}

</style>